import React from 'react';

import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import Grid from 'infrastructure/js/components/Grid/gridWrapper';
import {gridsNames} from '../../../../../enums/gridsNames';
import {filterTypes} from 'infrastructure/js/enums/filterTypes';
import MultiRowsCell from '../../../../../../../infrastructure/js/components/Grid/MulitRowsCell/multiRowsCell';
import LabelWithTooltipCell from "../../../../Common/CustomGridCells/LabelWithTooltipCell/labelWithTooltipCell";

export default class AlertDevicesViewGrid extends React.PureComponent{

  filterConfig = [  ];

  constructor (props){
    super(props);

    this.labels = createLabelHelper('mat.administration.rfidsettings.alertdevices.grid.');
    this.columnsConfig = this.createColumnsConfig();
  }

  createColumnsConfig = () => {
    return [
      {
        fieldName: 'name',
        title: this.labels.get('columns.devicename.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          sortable: false,
          cellComponent: LabelWithTooltipCell,
          valueGetter: (params) => {
            return params.data.name;
          }
        }
      },
      {
        fieldName: 'reader.name',
        title: this.labels.get('columns.host.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          sortable: false,
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'gpoId',
        title: this.labels.get('columns.gpo.title'),
        filterType: filterTypes.NONE,
        width: 100,
        columnOptions: {
          sortable: false,
        }
      },
      {
        fieldName: 'discoAntennas',
        title: this.labels.get('columns.antennas.title'),
        filterType: filterTypes.NONE,
        //filterName: 'discoAntennas',
        columnOptions: {
          sortable: false,
          cellComponent: MultiRowsCell,
          valueGetter: (params) => {
            return {
              dataList: params.data.discoAntennas.map(antenna =>  (antenna.name)),
              componentType: LabelWithTooltipCell
            };
          }
        }
      },
      {
        fieldName: 'businessRules',
        title: this.labels.get('columns.rules.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          sortable: false,
          cellComponent: MultiRowsCell,
          valueGetter: (params) => {
            return {
              dataList: params.data.businessRules.map(rule =>  ( (rule.propertyName + ' ' + rule.ruleOperatorDisplayName + ' ' + rule.value))),
              componentType: LabelWithTooltipCell
            };
          }
        }
      },
    ]
  };

  getRowHeight(params) {
    let rowHeight =  64;
    let value1 = params.data.discoAntennas ? params.data.discoAntennas.length : 0;
    let value2 = params.data.businessRules ? params.data.businessRules.length : 0;
    let cellRowsNumber = Math.max(value1, value2);
    if (cellRowsNumber > 1) {
      rowHeight = cellRowsNumber * 30 + 40;
    }
    return rowHeight;
  }

  render() {
    return (
      <div className="administration-view-grid">
        <Grid gridName={gridsNames.ADMINISTRATION_RFID_SETTINGS_ALERT_DEVICES}
              columnsConfig = {this.columnsConfig}
              actions={this.props.actions}
              filterConfig={this.filterConfig}
              gridProps={
                {getRowHeight: this.getRowHeight}
              }
        >
        </Grid>
      </div>
    );
  }
}

